import { FC, useEffect, useState } from "react";
import { Button as ButtonComponent, Collapse, Table } from "reactstrap";
import { AccordionCollapseProps } from "./AccordionCollapse.constants";
import { getOperationTypes } from "../../../modules/CustomerProfile/CustomerProfile.constants";

const AccordionCollapse: FC<AccordionCollapseProps> = ({ accordionList }) => {
  const [selectedCollapse, setSelectedCollapse] = useState<any>();

  const onSelectAccordionHandler = (index: number) => {
    setSelectedCollapse(index);
  };

  useEffect(() => {
    setSelectedCollapse(accordionList?.count && accordionList?.count - 1);
  }, [accordionList]);

  return (
    <div className="accordion accordion-flush" id="accordionFlushExample">
      {accordionList?.results.map((accordionItem, index) => {
        return (
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFlushOne">
              <button
                className={`accordion-button fw-medium ${
                  selectedCollapse === index ? "collapsed" : ""
                }`}
                type="button"
                onClick={() =>
                  onSelectAccordionHandler(
                    selectedCollapse === index ? -1 : index
                  )
                }
                style={{ cursor: "pointer" }}
              >
                {"Bakım " + (index + 1)}
              </button>
            </h2>

            <Collapse
              isOpen={index === selectedCollapse}
              className="accordion-collapse"
            >
              <div style={{ padding: 0 }} className="accordion-body">
                <div className="border rounded">
                  <div className="table-responsive">
                    <Table className="table-nowrap align-middle mb-0">
                      <tbody>
                        <tr key={"key"}>
                          <h5 className="font-size-15 mb-1">
                            {"Cihaz Modeli"}
                          </h5>
                          <td></td>
                          <td className="text-end">
                            {accordionItem?.customer_device_name ||
                              "Silinmiş Cihaz"}
                          </td>
                        </tr>

                        <tr key={"key"}>
                          <h5 className="font-size-15 mb-1">
                            {"Yapılan işlem"}
                          </h5>
                          <td></td>
                          <td
                            style={{ whiteSpace: "normal" }}
                            className="text-end"
                          >
                            {accordionItem?.procedure}
                          </td>
                        </tr>

                        <tr key={"key"}>
                          <h5 className="font-size-15 mb-1">{"Not"}</h5>
                          <td></td>
                          <td className="text-end">{accordionItem?.note}</td>
                        </tr>

                        <tr key={"key"}>
                          <h5 className="font-size-15 mb-1">
                            {"Bakım Tarihi"}
                          </h5>
                          <td></td>
                          <td className="text-end">
                            {accordionItem?.maintenance_date !== null &&
                              accordionItem?.maintenance_date.split("T")[0]}
                          </td>
                        </tr>

                        <tr key={"key"}>
                          <h5 className="font-size-15 mb-1">
                            {"Bakımı Yapan"}
                          </h5>
                          <td></td>
                          <td className="text-end">
                            {accordionItem?.person_who_maintain?.fullname}
                          </td>
                        </tr>

                        <tr key={"key"}>
                          <h5 className="font-size-15 mb-1">
                            {"Sonraki Bakım"}
                          </h5>
                          <td></td>
                          <td className="text-end">
                            {accordionItem?.next_maintenance_date !== null &&
                              accordionItem?.next_maintenance_date.split(
                                "T"
                              )[0]}
                          </td>
                        </tr>

                        {!!accordionItem?.maintenance_materials.length && (
                          <tr>
                            <td colSpan={2} className="text-start">
                              Malzemeler
                            </td>
                            <td className="text-end">{""}</td>
                          </tr>
                        )}

                        {accordionItem.maintenance_materials.map(
                          (materials) => {
                            return (
                              <>
                                <tr>
                                  <td
                                    colSpan={2}
                                    className="border-0 text-start"
                                  >
                                    <strong>
                                      {materials.device_part.name}
                                    </strong>
                                  </td>
                                  <td className="border-0 text-end">
                                    {getOperationTypes(
                                      materials.operation_type
                                    )}
                                  </td>
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
};

export default AccordionCollapse;
